module.exports = __webpack_public_path__ + "static/img/hos.6501238.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hos.jpg
// module id = 9NAW
// module chunks = 0